'use client'
import Link from 'next/link'
import React from 'react'

export default function error() {
  return (
    <div className='h-full bg-white' style={{ border: '1px solid black' }}>
      {/* preloader */}
      {/* preloader end */}
      {/* header area */}

      {/* header area end */}
      {/* popup search */}
      {/* popup search end */}
      {/* sidebar-popup */}

      {/* sidebar-popup end */}
      <main className="main bg-white">
        {/* breadcrumb */}
        {/* <div
            className="site-breadcrumb"
            style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
          >
            <div className="container">
              <h2 className="breadcrumb-title">404 Error</h2>
              <ul className="breadcrumb-menu">
                <li>
                  <a href="index-2.html">Home</a>
                </li>
                <li className="active">404 Error</li>
              </ul>
            </div>
          </div> */}
        {/* breadcrumb end */}
        {/* error area */}
        <div className="error-area py-120 ">
          <div className="container">
            <div className="col-md-8 mx-auto">
              <div className="error-wrap">
                <div className="error-img">
                  <img src="assets/img/error/404.png" alt="" />
                </div>
                <h2>Opos... Something Went Wrong!</h2>
                <p>
                  {/* The page you looking for not found may be it not exist or removed. */}
                  Please try again later.
                </p>
                <button onClick={() => window.location.reload()} className="theme-btn">
                  Reload Page <i className="far fa-home" />
                </button>

              </div>
            </div>
          </div>
        </div>
        {/* error area end */}
      </main>
      {/* footer area */}
      {/* footer area end */}
      {/* scroll-top */}

      {/* scroll-top end */}
      {/* js */}
    </div>
  )
}
